var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex justify-content-center align-items-center",style:({ height: _vm.height })},[_c('div',{ref:"funnelchart",style:({ height: _vm.height }),attrs:{"id":"funnelchart"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }